import { render, staticRenderFns } from "./PicMovement.vue?vue&type=template&id=6d540074&"
import script from "./PicMovement.vue?vue&type=script&lang=js&"
export * from "./PicMovement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports